import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Entity display names
export const ENTITY_LABELS = {
  national: 'REDLINE HQ',
  florida: 'Fire Watch Tampa Bay (FL)',
  newjersey: 'Fire Watch NJ',
  academy: 'Fire Watch Academy',
  technologies: 'Fire Watch Technologies'
};

// Get current user's profile + entity access
export async function getMyProfile() {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user) return null;
  const { data: profile } = await supabase.from('profiles').select('*').eq('id', user.id).single();
  const { data: entities } = await supabase.from('profile_entities').select('*').eq('profile_id', user.id);
  return { ...profile, entities: entities || [] };
}

export function canAccess(profile, entity) {
  if (!profile) return false;
  if (profile.role === 'admin') return true;
  return profile.entities.some(e => e.entity === entity);
}

export function hasFullAccess(profile, entity) {
  if (!profile) return false;
  if (profile.role === 'admin') return true;
  return profile.entities.some(e => e.entity === entity && e.access_level === 'full');
}

export function isManager(profile) {
  return profile && (profile.role === 'admin' || profile.role === 'manager');
}
